<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import VuetifyColorClass from '@/shared/constants/core/VuetifyColourClass'
import baseMixin from '@/mixins/baseMixin'
import { compileCustomProperties } from '@/helpers/log-helper'
import BaseButton from '@/components/_base-button.vue'
import featureFlagMixin from '@/mixins/featureFlagMixin'
import BookingFeedbackModal from './feedback/booking-feedback-modal.vue'

export default {
  name: 'BookingListFeedback',
  components: {
    BaseButton,
    BookingFeedbackModal,
  },
  mixins: [baseMixin, featureFlagMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
    buttonConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function() {
    return {
      dialog: false,
      quickFeedbackSuccess: false,
      VuetifyColorClass,
    }
  },
  computed: {
    ...mapGetters({
      isSubmittingQuickFeedback: 'bookings/isSubmittingQuickFeedback',
    }),
    bookingId() {
      return this.booking?.id
    },
    feedback() {
      return this.booking?.feedback
    },
    feedbackProvided() {
      return this.feedback.provided || this.quickFeedbackSuccess
    },
  },
  created() {
    this.debouncedTrackFeedbackClick = debounce(this.trackFeedbackClick, 1000)
  },
  methods: {
    ...mapActions({
      requestFeedbackFormUrl: 'bookings/requestFeedbackFormUrl',
      submitQuickFeedback: 'bookings/submitQuickFeedback',
    }),

    openFeedback() {
      this.dialog = true
      if (!this.isDev) this.debouncedTrackFeedbackClick()
    },

    trackFeedbackClick() {
      const customProperties = compileCustomProperties(
        this.$store,
        {
          bookingId: this.bookingId,
          timestamp: new Date().toISOString(),
        },
        true
      )
      this.$appInsights.trackEvent({
        name: 'FeedbackClick',
        properties: customProperties,
      })
    },
    handleFeedbackProvided() {
      this.quickFeedbackSuccess = true
    },
  },
}
</script>

<template>
  <div>
    <div v-if="selfServiceFeatureFlags.showBookingCardV2">
      <v-tooltip bottom :disabled="!feedbackProvided">
        <template v-slot:activator="{ on }">
          <div class="d-inline-block" v-on="on">
            <BaseButton
              v-bind="buttonConfig"
              tertiary
              :disabled="feedbackProvided"
              sm
              fab
              :icon="
                feedbackProvided
                  ? 'mdi-message-check-outline'
                  : 'mdi-message-alert-outline'
              "
              class="provide-feedback-btn"
              @click="openFeedback"
            />
          </div>
        </template>
        <span>{{
          feedbackProvided
            ? $t('feedback.feedbackProvidedText')
            : $t('feedback.provideFeedbackBtn')
        }}</span>
      </v-tooltip>
    </div>
    <div v-else>
      <div v-if="feedbackProvided">
        <v-icon small color="green" class="mr-1">mdi-check</v-icon>
        {{ $t('feedback.feedbackProvidedText') }}
      </div>
      <v-btn
        v-else
        small
        text
        class="ml-n4 provide-feedback-btn"
        @click="openFeedback"
        >{{ $t('feedback.provideFeedbackBtn') }}</v-btn
      >
    </div>

    <BookingFeedbackModal
      v-model="dialog"
      :booking="booking"
      @feedbackProvided="handleFeedbackProvided"
    />
  </div>
</template>
